const EMPTY_INSTANCE = {};
class TeaJsb {
  init(initOpts) {
    if (!("jsb" in initOpts))
      throw Error("[Tea JSB] must pass jsb into init func");
    const { jsb } = initOpts;
    this._jsb = jsb;
    this._setSendLogFunc();
  }
  _setSendLogFunc() {
    const { _jsb } = this;
    if (_jsb.x.reportAppLog) {
      this._sendLogFunc = _jsb.x.reportAppLog.bind(_jsb.x);
    } else if (_jsb.app.sendLogV3) {
      this._sendLogFunc = _jsb.app.sendLogV3.bind(_jsb.app);
    } else if (_jsb.x.sendLogV3) {
      this._sendLogFunc = _jsb.x.sendLogV3.bind(_jsb.x);
    } else {
      throw Error("[Tea] jsb doesn't have x.sendLogV3/x.reportAppLog/app.sendLogV3 method");
    }
  }
  collectEvent(eventData) {
    const params = {
      ...this._globalParams,
      ...eventData.params
    };
    if (this._sendLogFunc) {
      this._sendLogFunc({
        eventName: eventData.eventName,
        params
      });
    }
  }
  setGlobalEventParams(eventParams) {
    if (!eventParams)
      return;
    this._globalParams = Object.assign({}, eventParams);
  }
  config(config) {
    this.setGlobalEventParams(config.evtParams);
  }
  start() {
  }
  call() {
  }
  create() {
    return new TeaJsb();
  }
  constructor() {
    this._jsb = EMPTY_INSTANCE;
    this._globalParams = {};
    this._sendLogFunc = null;
  }
}
export {
  TeaJsb
};

//# sourceMappingURL=jsb-sdk.js.map